import { FileSystem } from "../os/FileSystem.ts";

const fileSystem = new FileSystem();
export const useFileSystem = () => {
    return fileSystem;
  };
  
